import { render, staticRenderFns } from "./LandingWishlistIT.vue?vue&type=template&id=32e3104a&scoped=true"
import script from "./LandingWishlistIT.vue?vue&type=script&lang=js"
export * from "./LandingWishlistIT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e3104a",
  null
  
)

export default component.exports